export const state = () => ({
})

export const mutations = {
}

export const actions = {
  async registerAsOwnerClinic ({ commit, state }, payload) {
    return await this.$axios.post('/clinic/register', payload)
  },
  async checkPublicID ({ commit, state }, payload) {
    return await this.$axios.post('/clinic/publicid/availability', payload)
  },
  async suggestionPublicID ({ commit, state }, payload) {
    return await this.$axios.post('/clinic/publicid/suggestions', payload)
  },
  async resendEmail ({ commit }, payload) {
    return await this.$axios.post('/clinic/email/resend', payload)
  }
}
